import { cn } from '@verlo/shared/lib/utils';

// One person, the same everywhere in People (Back office sweep, Oct 2026): initials in a
// proper circle, the full name, the role under it, smaller and muted. Team, Rota and
// Timesheets all lead each row with it.

export const initials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return ((parts[0][0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
};

export function Avatar({ name, size = 'md', className }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid shrink-0 place-items-center rounded-full bg-verlo-tint font-heading font-extrabold text-verlo',
        size === 'sm' ? 'h-7 w-7 text-[11px]' : 'h-8 w-8 text-[11.5px]',
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}

export default function Person({ name, role, size = 'md', after, className }) {
  return (
    <span className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <Avatar name={name} size={size} />
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="flex min-w-0 items-center gap-1.5">
          <span className="truncate text-[14px] font-semibold text-ink">{name}</span>
          {after}
        </span>
        {role && <span className="truncate text-[12px] text-ink-faint">{role}</span>}
      </span>
    </span>
  );
}
